import { ContainerModalToken } from "./localStyle";

const ModalToken = ({ dissmiss }) => {
  return (
    <ContainerModalToken>
      <span>
        No hemos podido verificar tu token. Te pedimos por favor que lo ingreses
        nuevamente.
      </span>
      <button className="btn" onClick={dissmiss}>
        Ingresar token nuevamente
      </button>
    </ContainerModalToken>
  );
};

export default ModalToken;
